<svg 
	[attr.width]="container.w" 
	[attr.height]="container.h">

  <line *ngFor="let line of timeLine.lines" 
    [attr.x1]="line.x1"
    [attr.y1]="line.y1"    
    [attr.x2]="line.x2"    
    [attr.y2]="line.y2"    
    [attr.stroke]="line.stroke"
    [attr.stroke-width]="line.stroke_width"
    [attr.stroke-dasharray]="line.stroke_dasharray"
  />

  <ng-container *ngFor="let spot of timeLine.spots" >
    <circle  
    [attr.stroke]="spot.stroke"
		[attr.cx]="spot.point.x"
		[attr.cy]="spot.point.y"
		[attr.r]="spot.radius" 
		[attr.fill]="spot.fill"
    [attr.stroke-width]="spot.stroke_width"
    />

    <ng-container *ngIf="!spot.vertical">
      <text [attr.x]="spot.titleX" [attr.class]="spot.titleStyle" y="50"> {{spot.title}} {{spot.duration || '' }}</text>
      <text [attr.x]="spot.messageX" [attr.class]="spot.messageStyle" y="10"> {{spot.message}}</text>
    </ng-container >

    <ng-container *ngIf="spot.vertical">
      <text [attr.y]="spot.titleY" [attr.class]="spot.titleStyle" [attr.x]="spot.titleX" *ngIf="showTitle"> {{spot.title}}</text>
      <text [attr.y]="spot.messageY" [attr.class]="spot.messageStyle" x="10"> {{spot.message}}</text>
    </ng-container >

    <ng-container *ngIf="spot.state === 'PAST'">
      <line class="tick" 
      [attr.x1]="spot.tick.p1.x" 
      [attr.y1]="spot.tick.p1.y" 
      [attr.x2]="spot.tick.p2.x" 
      [attr.y2]="spot.tick.p2.y" 
      />
      <line class="tick" 
      [attr.x1]="spot.tick.p3.x" 
      [attr.y1]="spot.tick.p3.y" 
      [attr.x2]="spot.tick.p4.x" 
      [attr.y2]="spot.tick.p4.y" 
      />
    </ng-container >

    <ng-container *ngIf="spot.state === 'CURRENT' && tooltipEnabled">
      <circle [attr.class]="timeLine.currentSpotState" 
      
      matTooltip={{shipment.exceptionMessage}} matTooltipClass={{getExceptionSeverityClass(shipment.exceptionSeverity)}}
      matTooltipClass="above"
      [attr.cx]="spot.point.x"
      [attr.cy]="spot.point.y"
      [attr.r]="5"
      />
    </ng-container>
     <ng-container *ngIf="spot.state === 'CURRENT' && !tooltipEnabled">
      <circle [attr.class]="timeLine.currentSpotState"
      [attr.cx]="spot.point.x"
      [attr.cy]="spot.point.y"
      [attr.r]="5"
      />
    </ng-container>

  </ng-container>  
    
</svg>
